var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.290039,
    width: 45,
    height: 45,
    rx: 22.5,
    fill: "#009B4B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3 14.29H13.7C12.49 14.29 11.511 15.2463 11.511 16.415L11.5 29.165C11.5 30.3338 12.49 31.29 13.7 31.29H31.3C32.51 31.29 33.5 30.3338 33.5 29.165V16.415C33.5 15.2463 32.51 14.29 31.3 14.29ZM30.86 18.8057L23.083 23.5019C22.731 23.7144 22.269 23.7144 21.917 23.5019L14.14 18.8057C14.0297 18.7459 13.9331 18.6651 13.8561 18.5681C13.779 18.4712 13.7232 18.3602 13.6918 18.2419C13.6605 18.1235 13.6544 18.0002 13.6738 17.8795C13.6932 17.7588 13.7378 17.6431 13.8048 17.5395C13.8718 17.4359 13.96 17.3465 14.0638 17.2767C14.1676 17.207 14.2851 17.1583 14.4089 17.1336C14.5328 17.1089 14.6606 17.1088 14.7846 17.1332C14.9085 17.1577 15.026 17.2061 15.13 17.2757L22.5 21.7275L29.87 17.2757C29.974 17.2061 30.0915 17.1577 30.2155 17.1332C30.3394 17.1088 30.4672 17.1089 30.5911 17.1336C30.7149 17.1583 30.8324 17.207 30.9362 17.2767C31.04 17.3465 31.1282 17.4359 31.1952 17.5395C31.2622 17.6431 31.3068 17.7588 31.3262 17.8795C31.3456 18.0002 31.3395 18.1235 31.3082 18.2419C31.2768 18.3602 31.221 18.4712 31.1439 18.5681C31.0669 18.6651 30.9703 18.7459 30.86 18.8057Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email_icon.53b6f051a0f8eae2a07588a46d1c7138.svg";
export { ForwardRef as ReactComponent };